import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { AgGridAngular } from "ag-grid-angular";
import { BehaviorSubject } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { SubSink } from "subsink2";

@Component({
  selector: "app-pagination-client-side-v2",
  templateUrl: "./pagination-client-side-v2.component.html",
  styleUrls: ["./pagination-client-side-v2.component.css"],
})
export class PaginationClientSideV2Component implements OnInit {
  @Input() agGridReference: AgGridAngular;
  @Output() onMorePageClick = new EventEmitter<any>();
  @Output() nextListing = new EventEmitter<any>();
  @Output() onRowsChange = new EventEmitter<any>();
  @Output() previousListing = new EventEmitter<any>();

  private subs = new SubSink();

  rowPerPage = 10;
  currentPage: number;
  totalPage: BehaviorSubject<number>;
  getRowClass = (params) => {
    if (params.node.rowIndex % 2 === 1) {
      return "ag-grid-odd-rows";
    }
    return "";
  };
  showMorePage: boolean = false;
  disablePreviousButton: boolean = true;

  constructor() {
    this.currentPage = 1;
    this.totalPage = new BehaviorSubject<number>(1);
  }

  ngOnInit() {
    this.subs.sink = this.agGridReference.gridReady
      .pipe(
        map(() => this.agGridReference.api.paginationGetTotalPages()),
        map((b) => (b ? this.totalPage.next(b) : this.totalPage.next(1))),
        switchMap(() => this.agGridReference.paginationChanged.asObservable()),
        map(() => this.agGridReference.api.paginationGetTotalPages())
      )
      .subscribe((resolve) => {
        resolve ? this.totalPage.next(resolve) : this.totalPage.next(1);
        this.currentPage =
          this.currentPage > this.totalPage.getValue() ? 1 : this.currentPage;
      });
  }

  onRowChange(row: number) {
    this.rowPerPage = row;
    this.agGridReference.api.paginationSetPageSize(row);
    this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
    if (row > 5) {
      this.agGridReference.api.setDomLayout("normal");
    } else {
      this.agGridReference.api.setDomLayout("autoHeight");
    }
    if (this.totalPage.getValue() <= 1) {
      this.onRowsChange.emit();
    }
  }

  // firstPage() {
  //   this.agGridReference.api.paginationGoToFirstPage();
  //   this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
  // }

  previousPage() {
    this.agGridReference.api.paginationGoToPreviousPage();
    this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
    if (this.totalPage.getValue() <= 1) {
      this.previousListing.emit();
    }
  }

  nextPage() {
    this.agGridReference.api.paginationGoToNextPage();
    this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
    this.disablePreviousButton = false;
    console.log(this.totalPage.getValue());
    if (this.totalPage.getValue() <= 1) {
      this.nextListing.emit();
    }
  }

  // lastPage() {
  //   this.agGridReference.api.paginationGoToLastPage();
  //   this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
  // }

  // morePage() {
  //   this.onMorePageClick.emit();
  // }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
